import { Injectable } from '@angular/core';
import { AuthConfig } from 'angular-oauth2-oidc';
import { ConfigurationService } from '../../shared/services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class AuthConfigService {

  constructor(private configurationService: ConfigurationService) { }

  getConfiguration(): AuthConfig {
    return {

      // Url of the Identity Provider
      issuer: this.configurationService.configuration.oauth.issuer,

      // URL of the SPA to redirect the user to after login
      redirectUri: this.configurationService.configuration.oauth.redirectUri,
      revocationEndpoint: this.configurationService.configuration.oauth.redirectUri,
      // The SPA's id.
      // The SPA is registerd with this id at the auth-serverß
      clientId: this.configurationService.configuration.oauth.clientId,

      responseType: this.configurationService.configuration.oauth.responseType,
      // set the scope for the permissions the client should request
      // The first three are defined by OIDC.
      scope: this.configurationService.configuration.oauth.scope,
      // Remove the requirement of using Https to simplify the demo
      // THIS SHOULD NOT BE USED IN PRODUCTION
      // USE A CERTIFICATE FOR YOUR IDP
      // IN PRODUCTION
      requireHttps: this.configurationService.configuration.oauth.requireHttps,
      // at_hash is not present in JWT token
      showDebugInformation: this.configurationService.configuration.oauth.showDebugInformation,
      disableAtHashCheck: this.configurationService.configuration.oauth.disableAtHashCheck
    };
  }
}
